export type RQLFieldType = "string" | "number" | "boolean";

export type RQLOperator =
  "=" | "!=" | ">" | ">=" | "<" | "<=" | "and" | "or" | "(" | ")";

export type RQLToken = {
  type: "field" | "operator" | "value" | "parenthesis";
  value: string;
  position: number;
};

export type RQLASTNode =
  | {
      type: "comparison";
      field: string;
      operator: "=" | "!=" | ">" | ">=" | "<" | "<=";
      value: string | number;
    }
  | {
      type: "logical";
      operator: "and" | "or";
      left: RQLASTNode;
      right: RQLASTNode;
    }
  | {
      type: "group";
      expression: RQLASTNode;
    };

export type RQLFieldDefinition = {
  name: string;
  type: RQLFieldType;
  accessor: (data: any) => any;
  allowedValues?: readonly string[];
};

export class RQLError extends Error {
  public position?: number;

  constructor(message: string, position?: number) {
    super(message);
    this.name = "RQLError";
    this.position = position;
  }
}

export class RQLTokenizerError extends RQLError {
  constructor(message: string, position?: number) {
    super(message, position);
    this.name = "RQLTokenizerError";
  }
}

export class RQLParserError extends RQLError {
  constructor(message: string, position?: number) {
    super(message, position);
    this.name = "RQLParserError";
  }
}

export class RQLEvaluatorError extends RQLError {
  constructor(message: string) {
    super(message);
    this.name = "RQLEvaluatorError";
  }
}

export type RQLResult<T> =
  | {
      success: true;
      data: T[];
    }
  | {
      success: false;
      error: RQLError;
    };
